var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfeatureStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8951_135821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57062 0 0 3.58569 0 8C0 12.4143 3.57062 16 8 16C12.4294 16 16 12.4143 16 8C16 3.58569 12.4143 0 8 0ZM12.0075 13.6347L8 11.5254L3.99247 13.6347L4.74576 9.16008L1.50659 6.0113L5.98117 5.3484L8 1.2806L10.0038 5.3484L14.4934 5.99623L11.2392 9.16008L12.0075 13.6347Z",
    fill: "url(#paint0_linear_8951_135821)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_8951_135821_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00802601 -0.0437539 0.0220932 -0.0733501 8.04058 35.7691)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 859.377,
    height: 392.788,
    fill: "url(#paint1_diamond_8951_135821)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 859.377,
    height: 392.788,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_8951_135821)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 859.377,
    height: 392.788,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_8951_135821)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 859.377,
    height: 392.788,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_8951_135821)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.2394 9.16023L12.0078 13.6348L8.00024 11.5256L3.99271 13.6348L4.74601 9.16023L1.50684 6.01146L5.98141 5.34856L8.00024 1.28076L10.004 5.34856L14.4937 5.99639L11.2394 9.16023Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.60416668653488159,\"g\":0.53594422340393066,\"b\":0.22152778506278992,\"a\":1.0},\"position\":0.22279968857765198},{\"color\":{\"r\":0.88235294818878174,\"g\":0.81568628549575806,\"b\":0.36862745881080627,\"a\":1.0},\"position\":0.53391015529632568},{\"color\":{\"r\":0.73333334922790527,\"g\":0.60392159223556519,\"b\":0.20000000298023224,\"a\":1.0},\"position\":0.80055773258209229}],\"stopsVar\":[{\"color\":{\"r\":0.60416668653488159,\"g\":0.53594422340393066,\"b\":0.22152778506278992,\"a\":1.0},\"position\":0.22279968857765198},{\"color\":{\"r\":0.88235294818878174,\"g\":0.81568628549575806,\"b\":0.36862745881080627,\"a\":1.0},\"position\":0.53391015529632568},{\"color\":{\"r\":0.73333334922790527,\"g\":0.60392159223556519,\"b\":0.20000000298023224,\"a\":1.0},\"position\":0.80055773258209229}],\"transform\":{\"m00\":-16.052028656005859,\"m01\":44.186325073242188,\"m02\":-6.0265712738037109,\"m10\":-87.507858276367188,\"m11\":-146.70022583007812,\"m12\":152.87318420410156},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_8951_135821_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2394 9.16023L12.0078 13.6348L8.00024 11.5256L3.99271 13.6348L4.74601 9.16023L1.50684 6.01146L5.98141 5.34856L8.00024 1.28076L10.004 5.34856L14.4937 5.99639L11.2394 9.16023Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8951_135821",
    x1: 4.21843,
    y1: -2.30818e-7,
    x2: 11.2722,
    y2: 14.3967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_8951_135821",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#9A8938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53391,
    stopColor: "#E1D05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800558,
    stopColor: "#BB9A33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8951_135821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfeatureStatusIcon);
export default __webpack_public_path__ + "static/media/unfeature-status-icon.ac9e40548db8a06865ba384d6361172f.svg";
export { ForwardRef as ReactComponent };